import {
  AdminTodoResponse,
  QueueHealthStatus,
  SchedulerHealthStatus,
  SchedulerStatusResponse,
  SnapshotQueueResponse,
} from "../../../../services";
import { reviewableActionCount } from "../../utils/corporateActions";

// The API only escalates blocked jobs by age, so a fresh block would read Healthy beside a Critical attention row.
export const snapshotHealthStatus = ({
  status,
  coverageBlockedJobs,
  preHorizonCoverageBlockedJobs,
}: SnapshotQueueResponse): QueueHealthStatus =>
  status === "healthy" && coverageBlockedJobs > preHorizonCoverageBlockedJobs
    ? "warning"
    : status;

export const schedulersSummary = (
  schedulers: SchedulerStatusResponse[],
): string => {
  if (schedulers.length === 0) {
    return "None registered";
  }
  const countOf = (...statuses: SchedulerHealthStatus[]) =>
    schedulers.filter(({ status }) => statuses.includes(status)).length;
  const healthy = countOf("healthy");
  const needReview = countOf("critical", "warning");
  const unobserved = countOf("unknown");
  return [
    healthy > 0 && `${healthy} healthy`,
    needReview > 0 && `${needReview} need review`,
    unobserved > 0 && `${unobserved} not yet observed`,
  ]
    .filter(Boolean)
    .join(" · ");
};

export const pendingWorkCount = (todo: AdminTodoResponse): number =>
  reviewableActionCount(todo) +
  todo.instrumentsWithoutSourceCountry +
  todo.instrumentsWithoutPricing +
  todo.pendingTickerRequests;
